export abstract class ALookupRowsContainer {

	/* tslint:disable */
	FKLookupRows: any;
	/* tslint:enable */

	constructor() {
		this.FKLookupRows = {};
	}

}
